<div class="mt-1 mb-3 flex align-items-center gap-5">
  <p-buttonGroup>
    @if (activeUserStore.canAccessEntityAdder()) {
      <p-button
        size="small"
        severity="success"
        icon="fas fa-circle-plus"
        [rounded]="true"
        [outlined]="true"
        (click)="editBookmarkCategory(undefined)"
        label="Themenbereich"></p-button>

      <p-button
        size="small"
        severity="success"
        icon="fas fa-circle-plus"
        [rounded]="true"
        [outlined]="true"
        [routerLink]="[{ outlets: { bearbeiten: 'neu' } }]"
        label="Ansicht"></p-button>

      <p-button
        size="small"
        severity="success"
        icon="fas fa-circle-plus"
        [rounded]="true"
        [outlined]="true"
        (click)="editStory(undefined)"
        label="Bericht"></p-button>
    }
  </p-buttonGroup>

  <div class="ml-auto flex gap-3">
    <label for="published"><i class="fas fa-earth-europe"></i></label>
    <!-- NG21-MIGRATION(stufe-2): p-triStateCheckbox existiert seit PrimeNG 18 nicht mehr -> app-tri-state-checkbox (§8.4) -->
    <p-triStateCheckbox
      id="published"
      (ngModelChange)="updateFilter()"
      [(ngModel)]="filterQuery.published"
      inputId="published" />
  </div>
  <div class="flex gap-3 align-items-center">
    <app-topic-filter-dropdown
      (selectedTopicsChange)="onTopicsChange($event)"
      [selectedTopics]="selectedTopics"></app-topic-filter-dropdown>
    <app-tag-filter-dropdown
      (selectedTagsChange)="updateFilter()"
      [(selectedTags)]="filterQuery.tags"></app-tag-filter-dropdown>
  </div>
  <div class="flex">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-12rem"
        pInputText
        placeholder="durchsuchen ..."
        [(ngModel)]="filterQuery.query"
        (ngModelChange)="updateFilter()" />
    </p-iconField>
  </div>
</div>
<p-divider></p-divider>
<div class="card">
  <p-treeTable
    [value]="treeTableData()"
    [columns]="cols"
    [scrollable]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-treetable-sm"
    (onNodeExpand)="onNodeToggle($event, true)"
    (onNodeCollapse)="onNodeToggle($event, false)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [style.width]="col.width">
          <span class="flex gap-2 align-items-center">
            @if (col.icon) {
              <i [class]="col.icon"></i>
            }
            {{ col.header }}
          </span>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowNode
      let-rowData="rowData"
      let-columns="columns">
      <tr
        [ttRow]="rowNode"
        [class.cursor-pointer]="canEditRow(rowData)"
        [ngClass]="{ 'surface-50': rowData.private || rowData.unsorted }"
        (click)="onRowClick(rowData, $event)">
        <td
          *ngFor="let col of columns; let i = index"
          [style.width]="col.width">
          <div class="flex align-items-center">
            @switch (i) {
              @case (0) {
                <span (click)="$event.stopPropagation()">
                  <p-treeTableToggler [rowNode]="rowNode" />
                </span>
                <span class="flex gap-2 align-items-center">
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-regular fa-eye-slash text-500':
                        rowData.type === 'category' && rowData.private,
                      'fa-regular fa-bookmark text-orange-500':
                        rowData.type === 'category' && rowData.unsorted,
                      'fas fa-layer-group':
                        rowData.type === 'category' &&
                        !rowData.private &&
                        !rowData.unsorted,
                      'fas fa-note-sticky': rowData.type === 'bookmark',
                      'fas fa-file-lines': rowData.type === 'story',
                    }"></i>

                  <span
                    [class.font-italic]="rowData.private || rowData.unsorted"
                    [class.text-500]="rowData.private"
                    [class.text-orange-500]="rowData.unsorted"
                    [class.font-bold]="rowData.type === 'category'"
                    >{{ rowData.name }}</span
                  >
                  <i
                    *ngIf="rowData.type === 'category' && rowData.unsorted"
                    class="ml-2 fas fa-info-circle text-color-secondary"
                    pTooltip="Unsortierte Ansichten tauchen nicht im Atlas auf"></i>
                  @if (rowData.type === 'category' && rowNode?.node?.children) {
                    <p-badge
                      [value]="rowNode.node.children.length"
                      severity="info"></p-badge>
                  }
                </span>
              }
              @case (1) {
                <div class="flex flex-wrap gap-1">
                  @for (topic of rowData.topics; track $index) {
                    <p-tag
                      styleClass="px-2 cursor-pointer"
                      [icon]="'fas fa-' + topic.icon"
                      [value]="topic.title"
                      [rounded]="true"
                      pTooltip="Nach Thema filtern"
                      (click)="
                        filterByTopic(topic._id); $event.stopPropagation()
                      ">
                    </p-tag>
                  }
                </div>
              }
              @case (2) {
                <div class="flex gap-1 flex-wrap">
                  @for (tagId of rowData.tags; track $index) {
                    @if (tagStore.getById(tagId)?.title; as tagTitle) {
                      <p-tag
                        styleClass="px-2 cursor-pointer"
                        icon="fas fa-tag"
                        [value]="tagTitle"
                        [rounded]="true"
                        pTooltip="Nach Schlagwort filtern"
                        (click)="filterByTag(tagId); $event.stopPropagation()">
                      </p-tag>
                    }
                  }
                </div>
              }
              @case (3) {
                @if (rowData.type === 'bookmark' || rowData.type === 'story') {
                  <p-tag
                    [rounded]="true"
                    styleClass="cursor-pointer"
                    [value]="rowData.published ? 'öffentlich' : 'intern'"
                    [icon]="
                      rowData.published
                        ? 'fas fa-globe-europe'
                        : 'fas fa-house-user'
                    "
                    [severity]="rowData.published ? 'info' : 'secondary'"
                    pTooltip="Nach Sichtbarkeit filtern"
                    (click)="
                      filterByVisibility(rowData.published);
                      $event.stopPropagation()
                    "></p-tag>
                }
              }
              @case (4) {
                <div class="flex justify-content-end w-full">
                  @if (
                    (rowData.type === 'category' &&
                      !rowData.unsorted &&
                      !rowData.private) ||
                    rowData.type === 'bookmark' ||
                    rowData.type === 'story'
                  ) {
                    <p-button
                      [rounded]="true"
                      [text]="true"
                      size="small"
                      icon="fas fa-ellipsis-vertical"
                      severity="secondary"
                      pTooltip="Aktionen"
                      (onClick)="openMenu($event, rowData, menu)"></p-button>
                    <p-menu
                      #menu
                      [model]="rowMenuItems"
                      [popup]="true"
                      appendTo="body"></p-menu>
                  }
                </div>
              }
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</div>

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="editFormOverlayWidth"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
